/**
 * OrderTruckIcon — the "orders" glyph for GearGhost browser apps.
 *
 * The truck (not a cart) is deliberately the one order symbol across the
 * product: orders and the cart used to share a cart icon and were
 * indistinguishable. The original glyph was a filled truck exported from the
 * design file — no icon library ships it — so this is a hand-drawn outline
 * conversion of that same silhouette: rounded cargo box, two-piece cab with
 * its horizontal slot, two wheels. It follows lucide conventions (24-unit
 * viewBox, 2-unit stroke, round caps/joins, currentColor) so it matches
 * lucide-react nav icons rendered at the same size.
 *
 * apps/mobile intentionally keeps the original filled variant
 * (components/icons/OrderTruckIcon.tsx + assets/images/icons/orders.svg) —
 * same symbol, different weight per platform.
 */

export interface OrderTruckIconProps {
  /** Rendered width and height in px — the glyph is square. */
  width?: number;
  className?: string;
}

export function OrderTruckIcon({ width = 18, className }: OrderTruckIconProps) {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M15 17H4.5A3.5 3.5 0 0 1 1 13.5V6A4 4 0 0 1 5 2H11A4 4 0 0 1 15 6V17Z" />
      <path d="M18 10.5V5H19A4 4 0 0 1 23 9V10.5Z" />
      <path d="M18 13.5H23A3.5 3.5 0 0 1 19.5 17H18Z" />
      <circle cx="6.5" cy="20.25" r="2.25" />
      <circle cx="17.5" cy="20.25" r="2.25" />
    </svg>
  );
}
